import { render, staticRenderFns } from "./NumberOrdersPopup.vue?vue&type=template&id=732b6548"
import script from "./NumberOrdersPopup.vue?vue&type=script&lang=js"
export * from "./NumberOrdersPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports